module.exports = __webpack_public_path__ + "static/media/yoga-mat.5f3df12d.jpg";